<form [formGroup]="form" autocomplete="off">
  <mat-form-field>
    <mat-label>{{ labelText() }}</mat-label>
    <input matInput formControlName="searchQuery" [placeholder]="placeholder()" />
    @if (searchQuery.value) {
      <mat-icon matSuffix class="clear-input-field-button" (click)="clearSearch()">close</mat-icon>
    }
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>
</form>
